"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppId = void 0;
// https://github.com/wix-a/business-manager-api/blob/master/src/appDefIds.ts
var AppId;
(function (AppId) {
    AppId["Cashier"] = "14bca956-e09f-f4d6-14d7-466cb3f09103";
    AppId["Stores"] = "1380b703-ce81-ff05-f115-39571d94dfcd";
    AppId["Invoices"] = "13ee94c1-b635-8505-3391-97919052c16f";
    AppId["RecurringInvoices"] = "35aec784-bbec-4e6e-abcb-d3d724af52cf";
    AppId["Hotels"] = "135aad86-9125-6074-7346-29dc6a3c9bcf";
    AppId["ProGalleryLocal"] = "14271e46-b02c-8714-ee52-469d73638ff7";
    AppId["ProGallery"] = "14271d6f-ba62-d045-549b-ab972ae1f70e";
    AppId["ProGalleryStoreLocal"] = "147d0fa9-8fa8-2304-cbdc-ec9e1cc4837d";
    AppId["PhotoAlbum"] = "13ff8629-c1fc-e289-e81f-bc8c8968e9d6";
    AppId["ArtStore"] = "147ab90e-91c5-21b2-d6ca-444c28c8a23b";
    AppId["Bookings"] = "13d21c63-b5ec-5912-8397-c3a5ddb27a97";
    AppId["Events"] = "140603ad-af8d-84a5-2c80-a0f60cb47351";
    AppId["Members"] = "14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9";
    AppId["Music"] = "13bb5d67-1add-e770-a71f-001277e17c57";
    AppId["Video"] = "14409595-f076-4753-8303-9a86f9f71469";
    AppId["Wallet"] = "4aebd0cb-fbdb-4da7-b5d1-d05660a30172";
    AppId["WixPaidPlans"] = "1522827f-c56c-a5c9-2ac9-00f9e6ae12d3";
    AppId["WixCode"] = "CloudSiteExtension";
    AppId["Restaurants"] = "13e8d036-5516-6104-b456-c8466db39542";
    AppId["RestaurantsMenu"] = "13c1402c-27f2-d4ab-7463-ee7c89e07578";
    AppId["WixPaymentsDashboard"] = "WIX_PAYMENTS_DASHBOARD";
    AppId["Challenges"] = "2936472a-a1ed-4ae5-9f71-614313a9f4e7";
    AppId["Inbox"] = "141fbfae-511e-6817-c9f0-48993a7547d1";
})(AppId = exports.AppId || (exports.AppId = {}));
//# sourceMappingURL=AppId.js.map